
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * TradingRouteActionType enum
 */
class TradingRouteActionType {
  /**
   * Initialize enum with a given value
   * @param {TradingRouteActionType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof TradingRouteActionType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!TradingRouteActionType}
   * @param {!TradingRouteActionType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof TradingRouteActionType)) {
      throw new TypeError('Instance of TradingRouteActionType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!TradingRouteActionType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!TradingRouteActionType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === TradingRouteActionType.FORWARD_TO_GATEWAY.value) {
      return 'FORWARD_TO_GATEWAY'
    }
    if (this.value === TradingRouteActionType.CONFIRM.value) {
      return 'CONFIRM'
    }
    if (this.value === TradingRouteActionType.REJECT.value) {
      return 'REJECT'
    }
    if (this.value === TradingRouteActionType.CANCEL.value) {
      return 'CANCEL'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!TradingRouteActionType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!TradingRouteActionType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!TradingRouteActionType} Created enum
   */
  static fromObject (other) {
    return new TradingRouteActionType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
TradingRouteActionType.FORWARD_TO_GATEWAY = new TradingRouteActionType(0 + 0)
// noinspection PointlessArithmeticExpressionJS
TradingRouteActionType.CONFIRM = new TradingRouteActionType(0 + 1)
// noinspection PointlessArithmeticExpressionJS
TradingRouteActionType.REJECT = new TradingRouteActionType(0 + 2)
// noinspection PointlessArithmeticExpressionJS
TradingRouteActionType.CANCEL = new TradingRouteActionType(0 + 3)

export { TradingRouteActionType };

/**
 * Fast Binary Encoding TradingRouteActionType field model
 */
class FieldModelTradingRouteActionType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelTradingRouteActionType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the value
   * @this {!FieldModelTradingRouteActionType}
   * @param {TradingRouteActionType=} defaults Default value, defaults is new TradingRouteActionType()
   * @returns {!TradingRouteActionType} Result value
   */
  get (defaults = new TradingRouteActionType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new TradingRouteActionType(this.readInt32(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelTradingRouteActionType}
   * @param {!TradingRouteActionType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeInt32(this.fbeOffset, value.value)
  }
}

export { FieldModelTradingRouteActionType };
